import { render, staticRenderFns } from "./LabelDialog.vue?vue&type=template&id=4e0e4092&scoped=true"
import script from "./LabelDialog.vue?vue&type=script&lang=js"
export * from "./LabelDialog.vue?vue&type=script&lang=js"
import style0 from "./LabelDialog.vue?vue&type=style&index=0&id=4e0e4092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0e4092",
  null
  
)

export default component.exports